<ui-card>
    <h2>{{ 'change-requests.approvalFlow' | translate }}</h2>
    <div>
        <ui-approval-flow [approvalFlowSteps]="approvalFlowSteps"></ui-approval-flow>
    </div>
</ui-card>
